import React from "react";
import { Overlay, ModalContainer } from "./styles";
import { LegendsList } from "../LegendsList";

interface LegendTabComponentProps {
  onClose: () => void;
  isEmbedded?: boolean;
}

export default function LegendTabComponent({
  onClose,
  isEmbedded = false,
}: LegendTabComponentProps) {

  const content = (
    <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <LegendsList />
    </div>
  );

  if (isEmbedded) {
    return (
      <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
        {content}
      </div>
    );
  }

  return (
    <Overlay onClick={onClose}>
      <div id="legend-tab">
        <ModalContainer onClick={(e) => e.stopPropagation()}>
          {content}
        </ModalContainer>
      </div>
    </Overlay>
  );
}